import React, { Component } from "react";
import {
  Paper,
  FlatButton,
  RaisedButton,
  DropDownMenu,
  MenuItem,
  Subheader,
  Divider,
} from "material-ui";
import Loading from "../Loading";
import formatDate from "../../../utils/formatDate";
import PreviewClientNag from "./PreviewClientNag";

export default class CyclePreviews extends Component {
  constructor(props) {
    super(props);
    this.state = {
      clientIndex: 0,
    };

    this.handleNext = this.handleNext.bind(this);
    this.handlePrev = this.handlePrev.bind(this);
    this.renderButtons = this.renderButtons.bind(this);
  }

  handleNext() {
    let { clientIndex } = this.state;
    let { clients } = this.props;
    if (clientIndex < clients.length - 1) clientIndex += 1;
    this.setState({ clientIndex: clientIndex });
    if (this.props.checkEmail) this.props.checkEmail();
  }

  handlePrev() {
    const { clientIndex } = this.state;
    if (clientIndex > 0) {
      this.setState({ clientIndex: clientIndex - 1 });
    }
  }

  renderButtons() {
    if (!this.props.hideButtons) {
      return (
        <div>
          <FlatButton label="<" onClick={this.handlePrev.bind(this)} />
          {this.state.clientIndex + 1}
          <FlatButton label=">" onClick={this.handleNext.bind(this)} />
        </div>
      );
    }
  }

  render() {
    let { template, clients } = this.props;
    let { clientIndex } = this.state;
    let client = this.props.clients ? clients[clientIndex] : {};

    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      return (
        <div className="container">
          {this.renderButtons()}
          <br />
          <PreviewClientNag
            checkEmail={this.checkEmail || null}
            client={client}
            template={template}
            attachments={this.props.attachments}
            documents={this.props.documents}
          />
          {this.renderButtons()}
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/Email/CyclePreviews.js